import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Layout, Dropdown, Badge, Avatar, Menu, Space } from 'antd'
import {
  MenuOutlined,
  SearchOutlined,
  MoreOutlined,
  SettingOutlined,
  AppstoreOutlined,
  BellOutlined,
  CloudOutlined,
  MailOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  MessageOutlined,
  UserOutlined,
  CreditCardOutlined,
  InboxOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  MinusCircleOutlined,
  LogoutOutlined,
  FlagOutlined,
  FallOutlined,
  DatabaseOutlined,
} from '@ant-design/icons'

const { Header } = Layout
export default function Topbar({ onToggleSidebar, isSidebarOpen }) {
	const navigate = useNavigate();
	const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

	// Apps dropdown menu
	const appsMenu = (
		<Menu
			items={[
				{
					key: 'weather',
					label: 'Weather',
					icon: <CloudOutlined style={{ color: '#17a2b8' }} />,
				},
				{
					key: 'email',
					label: 'E-mail',
					icon: <MailOutlined style={{ color: '#28a745' }} />,
				},
				{
					key: 'calendar',
					label: 'Calendar',
					icon: <CalendarOutlined style={{ color: '#007bff' }} />,
				},
				{
					key: 'map',
					label: 'Map',
					icon: <EnvironmentOutlined style={{ color: '#dc3545' }} />,
				},
				{
					key: 'chat',
					label: 'Chat',
					icon: <MessageOutlined style={{ color: '#ffc107' }} />,
				},
				{
					key: 'profile',
					label: 'Profile',
					icon: <UserOutlined />,
					onClick: () => navigate('/users/editprofile'),
				},
				{
					type: 'divider',
				},
				{
					key: 'more',
					label: 'More',
					style: { textAlign: 'center' },
				},
			]}
			style={{ width: 200 }}
		/>
	);

	// Notifications dropdown menu
	const notificationsMenu = (
		<Menu
			style={{ width: 320, maxHeight: 400, overflowY: 'auto' }}
			items={[
				{
					key: 'header',
					label: (
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
							<span style={{ fontWeight: 'bold' }}>Notifications</span>
							<a style={{ color: '#ff4d4f' }}>Clear all</a>
						</div>
					),
					disabled: true,
				},
				{ type: 'divider' },
				{
					key: 'notif1',
					label: (
						<div>
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
								<FlagOutlined style={{ color: '#52c41a', marginRight: 8, fontSize: 18 }} />
								<span style={{ fontWeight: 500, flex: 1 }}>New subscription created</span>
								<span style={{ fontSize: 12, color: '#999' }}>2pm</span>
							</div>
							<div style={{ fontSize: 12, color: '#666', paddingLeft: 26 }}>
								Your customer subscribed for the basic plan. The customer will pay $25 per month.
							</div>
						</div>
					),
				},
				{ type: 'divider' },
				{
					key: 'notif2',
					label: (
						<div>
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
								<FallOutlined style={{ color: '#faad14', marginRight: 8, fontSize: 18 }} />
								<span style={{ fontWeight: 500, flex: 1, color: '#faad14' }}>Server #2 not responding</span>
								<span style={{ fontSize: 12, color: '#999' }}>1pm</span>
							</div>
							<div style={{ fontSize: 12, color: '#666', paddingLeft: 26 }}>
								Some technical error occurred needs to be resolved.
							</div>
						</div>
					),
				},
				{ type: 'divider' },
				{
					key: 'notif3',
					label: (
						<div>
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
								<MailOutlined style={{ color: '#1890ff', marginRight: 8, fontSize: 18 }} />
								<span style={{ fontWeight: 500, flex: 1 }}>2 new messages</span>
								<span style={{ fontSize: 12, color: '#999' }}>4pm</span>
							</div>
							<div style={{ fontSize: 12, color: '#666', paddingLeft: 26 }}>
								The last payment for your G Suite Basic subscription failed.
							</div>
						</div>
					),
				},
				{ type: 'divider' },
				{
					key: 'notif4',
					label: (
						<div>
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
								<Avatar src="../../dist/img/avatar.jpg" size={24} style={{ marginRight: 8 }} />
								<span style={{ fontWeight: 500, flex: 1 }}>Sandy Doe</span>
								<span style={{ fontSize: 12, color: '#999' }}>1pm</span>
							</div>
							<div style={{ fontSize: 12, color: '#666', paddingLeft: 32 }}>
								Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit
							</div>
						</div>
					),
				},
				{ type: 'divider' },
				{
					key: 'notif5',
					label: (
						<div>
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
								<DatabaseOutlined style={{ color: '#ff4d4f', marginRight: 8, fontSize: 18 }} />
								<span style={{ fontWeight: 500, flex: 1, color: '#ff4d4f' }}>99% server space occupied.</span>
								<span style={{ fontSize: 12, color: '#999' }}>1pm</span>
							</div>
							<div style={{ fontSize: 12, color: '#666', paddingLeft: 26 }}>
								consectetur, adipisci velit.
							</div>
						</div>
					),
				},
				{ type: 'divider' },
				{
					key: 'read-all',
					label: 'Read all',
					style: { textAlign: 'center' },
				},
			]}
		/>
	);

	// User dropdown menu
	const userMenu = (
		<Menu
			items={[
				{
					key: 'profile',
					label: 'Profile',
					icon: <UserOutlined />,
					onClick: () => navigate('/users/editprofile'),
				},
				{
					key: 'balance',
					label: 'My Balance',
					icon: <CreditCardOutlined />,
				},
				{
					key: 'inbox',
					label: 'Inbox',
					icon: <InboxOutlined />,
				},
				{
					key: 'settings',
					label: 'Settings',
					icon: <SettingOutlined />,
					onClick: () => navigate('/setting/companyinfo'),
				},
				{
					type: 'divider',
				},
				{
					key: 'status',
					label: 'Available',
					icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
					children: [
						{
							key: 'available',
							label: 'Available',
							icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
						},
						{
							key: 'busy',
							label: 'Busy',
							icon: <ClockCircleOutlined style={{ color: '#faad14' }} />,
						},
						{
							key: 'offline',
							label: 'Offline',
							icon: <MinusCircleOutlined style={{ color: '#ff4d4f' }} />,
						},
					],
				},
				{
					type: 'divider',
				},
				{
					key: 'logout',
					label: 'Log Out',
					icon: <LogoutOutlined />,
					onClick: () => navigate('/logout'),
				},
			]}
			style={{ width: 180 }}
		/>
	);
	
	const toggleMobileNav = () => {
		setIsMobileNavOpen(!isMobileNavOpen);
	};

	useEffect(() => {
		// Add CSS for mobile responsive styles
		const style = document.createElement('style');
		style.textContent = `
			@media (max-width: 768px) {
				.navbar.navbar-inverse.navbar-fixed-top a.toggle-left-nav-btn {
					left: 1px !important;
					position: absolute !important;
					top: 10px !important;
				}
				
				.mobile-only-view {
					display: inline-block !important;
				}
				
				.toggle-left-nav-btn {
					display: inline-block !important;
				}
				
				.topbar-left-section {
					order: 1 !important;
				}
				
				.topbar-logo {
					order: 2 !important;
					position: absolute !important;
					left: 50% !important;
					transform: translateX(-50%) !important;
				}
				
				.topbar-right-section {
					order: 3 !important;
				}
			}
			
			@media (min-width: 769px) {
				.mobile-only-view {
					display: none !important;
				}
				
				.topbar-left-section {
					display: flex !important;
					align-items: center !important;
					gap: 16px !important;
				}
				
				.topbar-logo {
					position: static !important;
					transform: none !important;
				}
				
				.topbar-right-section {
					display: flex !important;
				}
			}
		`;
		document.head.appendChild(style);
		
		return () => {
			document.head.removeChild(style);
		};
	}, []);



	return (
		<>
			<Header
				style={{
					position: 'fixed',
					top: 0,
					width: '100%',
					zIndex: 1000,
					background: '#001529',
					padding: '0 16px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					height: 64,
					lineHeight: '64px',
				}}
			>
				{/* Left Side - Logo and Menu Toggle */}
				<div className="topbar-left-section" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
					<div className="topbar-logo" style={{ display: 'flex', alignItems: 'center' }}>
						<Link to="/dashboard/analytics" style={{ display: 'flex', alignItems: 'center', height: 64 }}>
							{isSidebarOpen ? (
								<img 
									src="../../dist/img/logo.png" 
									alt="brand" 
									style={{ height: 55, objectFit: 'contain', maxWidth: '180px' }} 
								/>
							) : (
								<img 
									src="../../dist/img/cloudico.png" 
									alt="brand-icon" 
									style={{ width: 55, height:55, objectFit: 'contain' }} 
								/>
							)}
						</Link>
					</div>
					
					<MenuOutlined
						style={{ 
							fontSize: 20, 
							color: '#fff', 
							cursor: 'pointer',
							padding: '8px',
						}}
						onClick={onToggleSidebar}
					/>
				</div>

				{/* Right Side - Actions */}
				<div 
					className="topbar-right-section"
					id="mobile_only_nav" 
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: 20,
					}}
				>
					<Space size="large">
						{/* Settings Icon */}
						{/* <SettingOutlined
							style={{ fontSize: 20, color: '#fff', cursor: 'pointer' }}
						/> */}

						{/* Apps Dropdown */}
						{/* <Dropdown dropdownRender={() => appsMenu} trigger={['click']}>
							<AppstoreOutlined
								style={{ fontSize: 20, color: '#fff', cursor: 'pointer' }}
							/>
						</Dropdown> */}

						{/* Notifications Dropdown */}
						{/* <Dropdown dropdownRender={() => notificationsMenu} trigger={['click']}>
							<Badge count={5} offset={[-5, 5]}>
								<BellOutlined
									style={{ fontSize: 20, color: '#fff', cursor: 'pointer' }}
								/>
							</Badge>
						</Dropdown> */}

						{/* <li className="dropdown full-width-drp">
							<Link to="#" className="dropdown-toggle" data-toggle="dropdown"><i class="zmdi zmdi-more-vert top-nav-icon"></i></Link>
							<ul className="dropdown-menu mega-menu pa-0" data-dropdown-in="fadeIn" data-dropdown-out="fadeOut">
								<li className="product-nicescroll-bar row">
									<ul className="pa-20">
										<li className="col-md-3 col-xs-6 col-menu-list">
											<Link to="javascript:void(0);"><div className="pull-left"><i class="zmdi zmdi-landscape mr-20"></i><span class="right-nav-text">Dashboard</span></div><div class="pull-right"><i class="zmdi zmdi-caret-down"></i></div><div class="clearfix"></div></Link>
											<hr className="light-grey-hr ma-0" />
											<ul>
												<li>
													<Link to="index.html">Analytical</Link>
												</li>
												<li>
													<Link to="index2.html">Demographic</Link>
												</li>
												<li>
													<Link to="index3.html">Project</Link>
												</li>
												<li>
													<Link to="/users/editprofile">profile</Link>
												</li>
											</ul>
											<Link to="widgets.html"><div className="pull-left"><i class="zmdi zmdi-flag mr-20"></i><span class="right-nav-text">widgets</span></div><div class="pull-right"><span class="label label-warning">8</span></div><div class="clearfix"></div></Link>
											<hr className="light-grey-hr ma-0" />
											<Link to="documentation.html"><div className="pull-left"><i class="zmdi zmdi-book mr-20"></i><span class="right-nav-text">documentation</span></div><div class="clearfix"></div></Link>
											<hr className="light-grey-hr ma-0" />
										</li>
										<li className="col-md-3 col-xs-6 col-menu-list">
											<Link to="javascript:void(0);">
												<div className="pull-left">
													<i className="zmdi zmdi-shopping-basket mr-20"></i><span class="right-nav-text">E-Commerce</span>
												</div>
												<div className="pull-right"><span class="label label-success">hot</span>
												</div>
												<div className="clearfix"></div>
											</Link>
											<hr className="light-grey-hr ma-0" />
											<ul>
												<li>
													<Link to="e-commerce.html">Dashboard</Link>
												</li>
												<li>
													<Link to="product.html">Products</Link>
												</li>
												<li>
													<Link to="product-detail.html">Product Detail</Link>
												</li>
												<li>
													<Link to="add-products.html">Add Product</Link>
												</li>
												<li>
													<Link to="product-orders.html">Orders</Link>
												</li>
												<li>
													<Link to="product-cart.html">Cart</Link>
												</li>
												<li>
													<Link to="product-checkout.html">Checkout</Link>
												</li>
											</ul>
										</li>
										<li className="col-md-6 col-xs-12 preview-carousel">
											<Link to="javascript:void(0);"><div className="pull-left"><span class="right-nav-text">latest products</span></div><div class="clearfix"></div></Link>
											<hr className="light-grey-hr ma-0" />
											<div className="product-carousel owl-carousel owl-theme text-center">
												<Link to="#">
													<img src="../../dist/img/chair.jpg" alt="chair" />
													<span>Circle chair</span>
												</Link>
												<Link to="#">
													<img src="../../../../dist/img/chair2.jpg" alt="chair" />
													<span>square chair</span>
												</Link>
												<Link to="#">
													<img src="dist/img/chair3.jpg" alt="chair" />
													<span>semi circle chair</span>
												</Link>
												<Link to="#">
													<img src="../../dist/img/chair4.jpg" alt="chair" />
													<span>wooden chair</span>
												</Link>
												<Link to="#">
													<img src="../../dist/img/chair2.jpg" alt="chair" />
													<span>square chair</span>
												</Link>
											</div>
										</li>
									</ul>
								</li>
							</ul>
						</li> */}

						{/* User Profile Dropdown */}
						<Dropdown dropdownRender={() => userMenu} trigger={['click']}>
							<span style={{ cursor: 'pointer' }}>
								<Badge 
									status="success" 
									offset={[-5, 35]}
								>
									<Avatar 
										src="../../dist/img/user1.png" 
										size={40}
										style={{ border: '2px solid #52c41a' }}
									/>
								</Badge>
							</span>
						</Dropdown>
					</Space>
				</div>
			</Header>
		</>
	)
}
